import './App.css';

//React
import React from 'react';
import { 
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom';

//Audio
// import { playBGMusic } from './Components/BGMusic'; //this import will autoplay music.

//Pages
import Barriers from './Pages/Barriers';
import Joys from './Pages/Joys';
import Fear from './Pages/Fear';
import Joys2 from './Pages/Joys2';
import LostAndFound from './Pages/LostAndFound';
import About from './Pages/About';

//UI
import { WelcomeModal } from './Components/WelcomeModal';
import RootLayout from './Layouts/RootLayout';
import Milestones from './Pages/Milestones';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout/>}>
      {/* <Route path="index"/> */}
      <Route path="Barriers" element={<Barriers/>}/>
      <Route path='Joys' element={<Joys/>}/>
      <Route path='Fear' element={<Fear/>}/>
      <Route path='Joys2' element={<Joys2/>}/>
      <Route path='Lost&Found' element={<LostAndFound/>}/>
      <Route path='Milestones' element={<Milestones/>}/>
      <Route path='About' element={<About/>}/>
      <Route path="*" element={<></>} />
    </Route>
  )
)

function App() {

return (
  <React.Fragment>
    <RouterProvider router={router} />
    <WelcomeModal/>
  </React.Fragment> 
) 
}

export default App;
